module.exports = __webpack_public_path__ + "img/button-right.2760358e.png";